import { render, staticRenderFns } from "./SocialSharing.vue?vue&type=template&id=f555fec2&scoped=true&"
import script from "./SocialSharing.vue?vue&type=script&lang=js&"
export * from "./SocialSharing.vue?vue&type=script&lang=js&"
import style0 from "./SocialSharing.vue?vue&type=style&index=0&id=f555fec2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f555fec2",
  null
  
)

export default component.exports